import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=0dc85386"
import script from "./Drivers.vue?vue&type=script&lang=ts"
export * from "./Drivers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports